import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Epic%20Naruto%20anime%20inspired%20abstract%20background%20with%20warm%20orange%20red%20and%20dark%20tones%2C%20swirling%20energy%20like%20chakra%2C%20dynamic%20fire%20and%20wind%20elements%2C%20ninja%20scroll%20textures%2C%20atmospheric%20dramatic%20lighting%2C%20Japanese%20manga%20aesthetic%2C%20no%20characters%20visible&width=1600&height=900&seq=hero-bg-naruto&orientation=landscape"
          alt="火影黄漫导航背景"
          className="w-full h-full object-cover object-top"
          loading="eager"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/60 via-black/40 to-background-50"></div>
      </div>

      <div className="relative z-10 w-full max-w-4xl mx-auto px-4 md:px-6 text-center py-20">
        <div className="inline-flex items-center gap-2 bg-background-950/60 backdrop-blur-sm px-4 py-2 rounded-full mb-6">
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-fire-line text-primary-400 text-sm"></i>
          </div>
          <span className="text-xs text-foreground-200 font-medium">
            火影忍者成人向同人漫画 · 正版资源导航与创作指南
          </span>
        </div>

        <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-foreground-50 leading-tight mb-6">
          探索火影黄漫的
          <br />
          <span className="text-primary-400">完整创作生态</span>
        </h1>

        <p className="text-base md:text-lg text-foreground-200 max-w-2xl mx-auto mb-10 leading-relaxed">
          汇聚火影黄漫相关内容指引、绘师创作技巧与同人社区推荐，
          帮助爱好者快速找到优质内容入口，了解火影忍者成人向同人漫画的创作生态与文化脉络。
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <Link
            to="/category/ziyuan-daohang"
            className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-background-50 rounded-lg font-semibold text-sm hover:bg-primary-600 transition-all whitespace-nowrap"
          >
            <i className="ri-compass-3-line mr-2"></i>
            开始探索资源
          </Link>
          <Link
            to="/category/chuangzuo-jiqiao"
            className="w-full sm:w-auto px-8 py-3.5 bg-background-50/15 backdrop-blur-sm text-foreground-100 rounded-lg font-semibold text-sm hover:bg-background-50/25 transition-all border border-foreground-300/20 whitespace-nowrap"
          >
            <i className="ri-brush-line mr-2"></i>
            学习创作技巧
          </Link>
        </div>

        <div className="flex items-center justify-center gap-8 mt-14">
          {[
            { value: '180+', label: '收录文章' },
            { value: '6', label: '内容分类' },
            { value: '50K+', label: '月访问量' },
          ].map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="text-2xl md:text-3xl font-bold text-foreground-50 font-heading">
                {stat.value}
              </div>
              <div className="text-xs text-foreground-400 mt-1">{stat.label}</div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}